<template>
  <div class="flex flex-col w-full">
    <div class="text-[2rem] leading-[2.5rem] font-black text-[#433D31] tracking-[-0.03em]">
      New Password created!
    </div>
    <div class="text-[1rem] leading-[1.5rem] text-[#433D31] font-semibold pt-[8px]">
      You’re good to go!
    </div>
    <div class="text-[1rem] leading-[1.5rem] text-[#433D31] font-semibold pt-[8px]">
      Go back to the Login page and use your new password 🙂
    </div>
    <div class="mt-[24px] w-full">
      <BaseButton
        solid-classes="h-[56px] bg-[#42362B] border-0 !rounded-[100px] text-white text-[1rem] leading-[1.5rem] font-bold items-center"
        full-width
        @click="backToLogin"
      >
        Back to Login
      </BaseButton>
    </div>
  </div>
</template>
<script>
import BaseButton from '@/components/design/BaseButton.vue';
export default {
  components: {
    BaseButton,
  },
  methods: {
    backToLogin() {
      this.$router.push('/login');
    },
  },
};
</script>
